import React from 'react'
import { Link } from 'react-router-dom'


const Navbar = () => {
    return (
        <div>
            <header style={{backgroundColor: "#121212"}} className="text-white body-font">
                <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
                    <a className="flex title-font font-medium items-center text-white mb-4 md:mb-0">
                        
                        <span className="ml-3 text-xl">Portfolio</span>
                    </a>
                    <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
                        <Link className="mr-5 hover:text-white home-link" to='/'>Home</Link>
                        <Link className="mr-5 hover:text-white home-link" to='/about'>About</Link>
                        <Link className="mr-5 hover:text-white home-link" to='/project'>Projects</Link>
                        <Link className="mr-5 hover:text-white home-link" to='/skill'>Skills</Link>
                    </nav>
                    <Link to='/contact' className="inline-flex items-center bg-green-600 border-0 py-1 px-3 focus:outline-none hover:bg-blue-700 rounded text-base mt-4 md:mt-0">Contact Me
                        <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-1" viewBox="0 0 24 24">
                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                    </Link>
                </div>
            </header>
        </div>
    )
}

export default Navbar
